// work data

export const Work = [
    {
        id:1,
        name:"The Weirdos Club Clone",
        description:"A Clone of Weirdos Club to build using React JS, with styledComponents and GSAP for smooth scrolling animations.",
        tags:["react","gsap","styledComponents"],
        
        demo:"https://main--the-weirdos-club-fd5e5e.netlify.app/",
        github:"https://github.com/1813amit/Snabb-tech-"
    },
    {
        id:2,
        name:"Fashion Wibe Studio",
        description:"A Fashion Studio website build in ReactJS,with styledComponents, locomotive-Scroll for smooth scrolling.Also Gsap and Framer-motion for some custom animations and effects",
        tags:["react-js","gsap","styledComponents"],
        
        demo:"https://fasion-wibe-studio-website-mg-66be88.netlify.app/",
        github:"https://github.com/1813amit/clothshoewcase"
        
    },
    {
        id:3,
        name:"Todo App(React + Redux)",
        description:"A todo app build using Redux-toolkit and framer-motion for smooth animations.",
        tags:["react","redux","framer-motion"],
        
        demo:"https://react-redux-todo-app-mg-830ea.netlify.app/",
        github:"https://github.com/1813amit/REACT_REDUX_TODO_LIST"
        
    },
    {
        id:4,
        name:"Infos|Connect the brand",
        description:"A cool looking & responsive website build using HTML, CSS, JS, Gsap and other animations.It has really smooth animations.",
        tags:["HTML","CSS","JS","gsap"],
        
        demo:"https://animated-unicorn-2b9135.netlify.app/",
        github:"https://github.com/1813amit/Hoppy-Refresher"
       
    },{
        id:5,
        name:"Neverland-Agency-Clone",
        description:"A clone of Neverland-Agency-Clone to build using Html5, CSS3, JS, Gsap, locomotive-scroll .",
        tags:["HTML5","CSS3","JS","gsap"],
        
        demo:"http://neverland-agency-clone-f8a74b.netlify.app",
        github:"https://github.com/1813amit/Neverland-Agency-Clone"
    },
    {
        id:6,
        name:"Flora Responsive Website",
        description:"A reponsive website build using HTML5, CSS3, Javascript, Gsap, LocomotiveScroll, ScrollTrigger.js",
        tags:["Html5","javascript","css","gsap","locomotive-scroll"],
        
        demo:"http://flora-mg.netlify.app/",
        github:"https://github.com/1813amit/Flora_Flower_Webdesign"
        
    },
    
  
] 